import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeMX from '@angular/common/locales/es-MX';
/*Import router*/
import {routing, appRoutingProviders} from './app.routing';

//import { CookieService } from 'angular2-cookie/services/cookies.service';

import { AppComponent } from './app.component';
import { VariableService } from './services/sharedVariables';
import { CustomerComponent } from './components/customer.component';
import { ErrorComponent } from './components/error.component';
import { AuthComponent } from './components/auth.component';
import { AdminPanelComponent } from './components/admin-panel.component';
import { HeaderWebComponent } from './components/header.component';
import { FooterWebComponent } from './components/footer.component';
import { SideBarComponent } from './components/sidebar.component';
import { RoleComponent } from './components/role.component';
import { UserComponent } from './components/user.component';
import { EmployeeComponent } from './components/employee.component';
import { ProductsPanelComponent } from './components/products-panel.component';
import { MainPanelComponent } from './components/main-panel.component';
import { CorePanelComponent } from './components/core-panel.component';
import { WarehouseComponent } from './components/warehouse.component';
import { ProductComponent } from './components/product.component';
import { InventaryComponent } from './components/inventary.component';
import { ServiceComponent } from './components/service.component';
import { ContractComponent } from './components/contract.component';
import { BodyWebComponent } from './components/body.component';
import { PrinterComponent } from './components/printer.component';
import { SecureUrlPipe } from './secure-url.pipe';
import { SearchPipe } from './search.pipe';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { TicketComponent } from './components/ticket.component';
import { AccountComponent } from './components/account.component';
import { SearchTicketsComponent } from './components/search-tickets.component';
import {EventComponent} from './components/event.component';
registerLocaleData(localeMX);
@NgModule({
  declarations: [
    AppComponent,
    CustomerComponent,
    ErrorComponent,
    AuthComponent,
    AdminPanelComponent,
    HeaderWebComponent,
    FooterWebComponent,
    RoleComponent,
    UserComponent,
    EmployeeComponent,
    ProductsPanelComponent,
    MainPanelComponent,
    WarehouseComponent,
    ProductComponent,
    SideBarComponent,
    InventaryComponent,
    ServiceComponent,
    ContractComponent,
    CorePanelComponent,
    BodyWebComponent,
    PrinterComponent,
    SecureUrlPipe,
    SearchPipe,
    TicketComponent,
    AccountComponent,
    SearchTicketsComponent,
    EventComponent


  ],
  imports: [
  BrowserModule,
  FormsModule,
  HttpModule,
  routing,
  PdfViewerModule
  ],
  providers: [
    appRoutingProviders,VariableService,{provide: LOCALE_ID, useValue: 'es-MX' }
    ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/app.module.ts